/**
 * Custom functionality for the homepage.
 */

/* global jQuery, TweenMax, TimelineMax, Back, Bounce, Elastic, Quart */

const $                 = jQuery;   // jQuery loaded via WordPress enqueue process
const events            = require('../utilities/events');
// const clippedParallax   = require('../components/clipped-parallax');



/**
 * Init any parallax modules on the page
 */
/* function initClippedParallax() {
    // Set up 'Nonna Video Wall' background parallax
    let paraOptions2 = {
        container:          '.nonna-wall',
        bg:                 '.nonna-wall__bg',
        svg:                '.nonna-wall__bg-svg',
        image:              '.nonna-wall__bg-image',
        clipPath:           '#nonna-wall__bg-clip-path',
        clipShape:          '#nonna-wall__bg-clip-shape',
        clipPathWidth:      1366,
        clipPathHeight:     2200,
        imageWidth:         1366,
        imageHeight:        3200,
        intensity:          0.5,    // 0 - minimal effect | larger values increase effect
        bottomAnchor:       true    // Anchor bg at bottom of container (to be used with
                                    // css definition to bottom align bg block)           
    };
    clippedParallax.setupParallax(paraOptions2); 
} */

function initWallBg() {

    let $img = $('.nonna-wall__bg-image'),
        $svg = $('.nonna-wall__bg-svg'),
        imgNaturalWidth = 1366,
        imgNaturalHeight = 2200,
        scaleBreakPoint = 800,      // Width below which we need to scale down the bg
        $bg = $('.nonna-wall__bg'),
        imgRatio = imgNaturalHeight / imgNaturalWidth;  // Height / Width

    function setImageSize() {

        let imgWidth, imgHeight,
            winWidth = $(window).innerWidth();
        
        if (winWidth > imgNaturalWidth) {
            imgWidth = winWidth;
        } else if (winWidth > scaleBreakPoint) {
            // scaleBreakPoint is width above which content is shown at 100%
            imgWidth = imgNaturalWidth;
        } else {
            // Means screen is below scaleBreakPoint -- scale down the width
            imgWidth = imgNaturalWidth - (scaleBreakPoint - winWidth);
        }
        
        // Set height based on calculated width
        imgHeight = imgWidth * imgRatio;
        
        // Set image and svgsize
        $svg.attr('width', imgWidth).attr('height', imgHeight);
        $img.attr('width', imgWidth).attr('height', imgHeight);
        $bg.width(imgWidth);
    }

    $(window).resize(() => {
        setImageSize();
    });

    setImageSize();
}


/* function initUpperAnimation() {
    // Our text animation is comprised of a series of span elements,
    // each representing a word in a phrase.  The spans display a
    // portion of a background image, spelling out the phrase. Here,
    // we scale down the container based on the available screen
    // width, and keep it centered.  This allows us to maintain
    // the exact word placement and background positioning.
    let $animModule = $('.nonna-no__anim'),
        $animInnerWrap = $('.nonna-no__anim-inner'),
        imgWidth = 747;     // Based on 'master' size of the graphic

    // Set a fixed width on the container 
    $animInnerWrap.css('width', imgWidth + 'px');

    $(window).resize(() => {
        let parentWidth = $animModule.width(),
            parentWidthWithPadding = $animModule.innerWidth(),
            targetWidth = (parentWidth > imgWidth) ? imgWidth : parentWidth,
            scaleRatio = targetWidth / imgWidth,
            leftLoc = (parentWidth > imgWidth) 
                ? (parentWidthWithPadding - imgWidth) / 2 
                : (parentWidthWithPadding - parentWidth) / 2;

        $animInnerWrap.css('transform', 'scale(' + scaleRatio + ')').css('left', leftLoc + 'px');
    }).trigger('resize');

    // Prep our reveal animations
    let $word1 = $('.nonna-no__anim-element:nth-child(1)'),
        $word2 = $('.nonna-no__anim-element:nth-child(2)'),
        $word3 = $('.nonna-no__anim-element:nth-child(3)'),
        $word4 = $('.nonna-no__anim-element:nth-child(4)');

    // Set up our animation sequence, paused at start
    let noAnim = new TimelineMax({ 
        paused: true, 
        yoyo:true, 
        repeat:9999,
        repeatDelay:2
    });
    noAnim.from($word2, .4, { alpha: 0, scale: .3, ease: Quart.easeOut, x:70})
        .from($word3, .4, { alpha: 0, scale: .3, ease: Quart.easeOut, x:-70}, '-=0.35')
        .from($word4, .55, { alpha: 0, scale: 0, ease: Back.easeOut, x:-150}, '-=0.40')
        .from($word1, .55, { alpha: 0, scale: 0, ease: Back.easeOut, x:150}, '-=0.50');

    // Listen for reveal events (via ScrollReveal)
    $('body').on(events.REVEAL_START, (evt, domEl) => {
        let $el = $(domEl);
        if ($el.hasClass('nonna-no')) {
            setTimeout(() => {
                noAnim.play();
            }, 1200);
        }
    });
} */

function initLowerAnimation() {
    // Our text animation is comprised of a series of span elements,
    // each representing a word in a phrase.  The spans display a
    // portion of a background image, spelling out the phrase. Here,
    // we scale down the container based on the available screen
    // width, and keep it centered.  This allows us to maintain
    // the exact word placement and background positioning.
    let $animModule1 = $('.no-list__anim'),
        $animInnerWrap1 = $('.no-list__anim-inner'),
        img1Width = 630,    // Based on 'master' size of scaled down graphic (at 1/2 x)
        $animModule2 = $('.tastes-good__anim'),
        $animInnerWrap2 = $('.tastes-good__anim-inner'),
        img2Width = 532; 
        

    // Set a fixed width on the container 
    $animInnerWrap1.css('width', img1Width + 'px');
    $animInnerWrap2.css('width', img2Width + 'px');

    $(window).resize(() => {
        $.each([{ 
            module: $animModule1, 
            wrap: $animInnerWrap1,
            width: img1Width 
        }, {
            module: $animModule2, 
            wrap: $animInnerWrap2,
            width: img2Width 
        }], (index, item) => {
            let parentWidth = item.module.width(),
                parentWidthWithPadding = item.module.innerWidth(),
                targetWidth = (parentWidth > item.width) ? item.width : parentWidth,
                scaleRatio = targetWidth / item.width,
                leftLoc = (parentWidth > item.width) 
                    ? (parentWidthWithPadding - item.width) / 2 
                    : (parentWidthWithPadding - parentWidth) / 2;

            item.wrap.css('transform', 'scale(' + scaleRatio + ')').css('left', leftLoc + 'px');
        });
        
    }).trigger('resize');

    // Prep our reveal animations
    let $anim1Word1 = $('.no-list__anim-element:nth-child(1)'),
        $anim1Word2 = $('.no-list__anim-element:nth-child(2)'),
        $anim1Word3 = $('.no-list__anim-element:nth-child(3)'),
        $anim1Word4 = $('.no-list__anim-element:nth-child(4)'),
        $anim1Word5 = $('.no-list__anim-element:nth-child(5)'),
        $anim1Word6 = $('.no-list__anim-element:nth-child(6)'),
        $anim1Word7 = $('.no-list__anim-element:nth-child(7)');

    let $anim2Word1 = $('.tastes-good__anim-element:nth-child(1)'),
        $anim2Word2 = $('.tastes-good__anim-element:nth-child(2)'),
        $anim2Word3 = $('.tastes-good__anim-element:nth-child(3)'),
        $anim2Word4 = $('.tastes-good__anim-element:nth-child(4)'),
        $anim2Word5 = $('.tastes-good__anim-element:nth-child(5)'),
        $anim2Word6 = $('.tastes-good__anim-element:nth-child(6)'),  // "NO" - left burst
        $anim2Word7 = $('.tastes-good__anim-element:nth-child(7)'),  // "NO"
        $anim2Word8 = $('.tastes-good__anim-element:nth-child(8)');  // "NO" - right burst


    // Set up our animation sequence, paused at start
    let tastesGoodAnim = new TimelineMax({ paused: true, repeat:9999 });

    // Anim 1
    tastesGoodAnim.from([$anim1Word1, $anim1Word2], .3, { alpha: 0})
        .from([$anim1Word3, $anim1Word4, $anim1Word5], .3, { alpha: 0, delay:.4 })
        .from([$anim1Word6, $anim1Word7], .3, { alpha: 0, delay: .4} )
        .from([
            $anim2Word1, $anim2Word2, $anim2Word3, $anim2Word4, 
            $anim2Word5, $anim2Word6, $anim2Word7, $anim2Word8
        ], .3, { alpha: 0, delay: .6} );


    // Anim 2
/*     tastesGoodAnim.staggerFrom([$anim2Word1, $anim2Word2, $anim2Word3, $anim2Word4, $anim2Word5], 0.5, { x: 100, alpha: 0 }, 0.1)
        .from($anim2Word7, .5, {alpha:0, scale:0, ease: Back.easeOut}, '-=0.5')
        .from($anim2Word6, .35, { alpha: 0, scale: 0, ease: Back.easeOut, x:150}, '-=0.5')
        .from($anim2Word8, .35, { alpha: 0, scale: 0, ease: Back.easeOut, x:-150}, '-=0.5'); */

    // Fade out
    tastesGoodAnim.to([
        $anim1Word1, $anim1Word2, $anim1Word3, $anim1Word4, 
        $anim1Word5, $anim1Word6, $anim1Word7,
        $anim2Word1, $anim2Word2, $anim2Word3, $anim2Word4, 
        $anim2Word5, $anim2Word6, $anim2Word7, $anim2Word8
    ], 0.4, { alpha: 0, delay: 3 });

    // Listen for reveal events (via ScrollReveal)
    $('body').on(events.REVEAL_START, (evt, domEl) => {
        let $el = $(domEl);
        if ($el.hasClass('nonna-msg')) {
            setTimeout(() => {
                tastesGoodAnim.play();
            }, 300);
        }
    });
}



exports.init = function () {
    //initClippedParallax();
    // initUpperAnimation();
    initLowerAnimation();
    initWallBg();
};